<template>
  <div class="productModal">
    <div class="productModal-inner">
      <div class="productModal-close" @click="closeProductInfo()">
        &times;
      </div>

      <h3 class="productModal-title">
        {{ modalInfo.nombre }}
        <img
          src="../../../assets/box-arrow-up-right.svg"
          alt="nombre-curso"
          id="goToCourse-icon"
          @click="goToCourse()"
        />
      </h3>

      <div class="embed-responsive embed-responsive-21by9">
        <video src="@/assets/CARNET1.mp4" controls></video>
      </div>

      <!-- Eliminar asteriscos del HTML dinámico -->
      <p
        class="productModal-description"
        v-html="modalInfo.descripcion.replace(/\*/g, '')"
      ></p>

      <div class="productModal-extra">
        <span class="text-secondary">
          <img
            src="../../../assets/minicertificate.svg"
            alt="certificado Ipssoma"
          />
          Incluye certificado
        </span>
        <span class="text-secondary">
          <img
            src="../../../assets/minicertificate.svg"
            alt="curso virtual"
          />
          100% virtual
        </span>
      </div>

      <button
        type="button"
        class="btn btn-warning"
        id="productModal-btn"
        @click="openPaymentModal()"
        arial-label="comprar-ahora"
      >
        Comprar ahora
      </button>
    </div>
  </div>
</template>

<style scoped>
.productModal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  height: 100vh;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  display: grid;
  place-items: center;
}

.productModal-inner {
  background-color: #fff;
  color: #000;
  position: relative;
  width: 60%;
  max-height: 90vh;
  overflow-y: auto;
  border-radius: 15px;
  padding: 20px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

.productModal-close {
  position: absolute;
  height: 50px;
  width: 50px;
  top: 10px;
  right: 15px;
  font-size: 3rem;
  color: #ffc107;
  cursor: pointer;
  z-index: 1;
}

.productModal-title {
  display: inline-flex;
  align-items: center;
  font-size: 1.5rem;
  margin-bottom: 15px;
}

#goToCourse-icon {
  width: 30px; /* un poco más grande */
  height: 30px;
  fill: #ffc107; /* color amarillo */
  cursor: pointer;
  margin-left: 10px;
}

.productModal-description {
  color: #4a4a4a;
  font-size: 1rem;
  line-height: 1.6;
  margin: 20px 0;
}

.productModal-extra {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 30px;
}

.productModal-extra span {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.95rem;
}

.productModal-extra img {
  width: 30px;
}

#productModal-btn {
  border-radius: 15px;
  padding: 10px 50px;
  margin-left: auto;
  display: block;
}
</style>

<script>
    import { useProductInfo } from '../../../store/productModal';
    import { usePaymentModal } from '../../../store/paymentModal';

    export default{
        name: "ProductModal",
        data(){
            return{
            }
        },
        computed: {
            modalInfo(){
                return useProductInfo().$state.productModalInfo
            }
        },
        methods:{
            closeProductInfo(){
                this.$emit('closeProductInfo')
            },
            openPaymentModal(){
                const newProduct = useProductInfo().$state.productModalInfo
                usePaymentModal().updateModalInfo(newProduct)
                this.$emit('openPaymentModal')
            },
            goToCourse() {
                localStorage.setItem("mode", this.mode);
                var type = this.getProductType(this.modalInfo.tipo_producto_id) == null
                    ? "oferta"
                    : this.getProductType(this.modalInfo.tipo_producto_id);
                if (type == "oferta") {
                    const config = {
                        slug: this.modalInfo.slug,
                    };
                    this.$router.push({
                        name: "oferta",
                        params: config,
                    });
                }
                else {
                    const config = {
                        type: type,
                        slug: this.modalInfo.slug,
                    };
                    this.$router.push({
                        name: "producto",
                        params: config,
                    });
                }
            },
            getProductType(id) {
                if (id == 1) {
                    return "curso";
                }
                else if (id == 2) {
                    return "diplomado";
                }
            },
            redirectToPay() {
            // if (this.precio === 0) {
            //   const { ok } = await this.buyCourse(this.pao_id);
            //   if (!ok) return;
            //   this.$router.push({ name: "suscription-user" });
            // } else {
            // this.pao_id = 1;
            // this.$router.push("/buy/" + this.pao_id);
            this.$router.push("/" + this.modalInfo.slug + "/pay");
            // }
            },
        },
        props: {
            mode: {
                type: String,
                default: "private",
            },
            // showPrivateNavbar: {
            //   type: Boolean,
            //   default: false,
            // },
            width: Number,
            height: {
                type: String,
                default: "100%",
            },
            
        },
    }
</script>
